import React, { Component, Fragment } from 'react';
import { injectIntl } from 'react-intl';
import { bool } from 'prop-types';
import IntlInput from '../../../../components/common/IntlInput';
import ContractsInput from '../../../../components/Contracts/ContractsInput';
import { iFMessage, FMessage } from '../../../../hoc/IntlComponents';
import CustomControl from '../../../../components/CustomControl/CustomControl';

class ContractsIPForm extends Component {
    static propTypes = {
        loading: bool,
    };

    state = {
        match: false
    };

    handleChangeMatch = ({ target }) => {
        const { match } = this.state;
        const { getCommonProps } = this.props;
        this.setState(prevState => ({ match: !prevState.match }));
        const inputHandler = getCommonProps('actual_address', 0).onChange;
        const addresToCopyProps = getCommonProps('address', 0);
        const data = { name: 'actual_address', value: '' };
        if (!match) {
            data.value = addresToCopyProps.value;
        }
        inputHandler({ target: data });
    }

    getActAddressValue = () => {
        const { match } = this.state;
        const { getCommonProps } = this.props;
        const addresToCopyProps = getCommonProps('address', 0);
        const propsToReplace = getCommonProps('actual_address');
        return match ? addresToCopyProps.value : propsToReplace.value;
    }

    getActAddressError = () => {
        const { match } = this.state;
        const { getCommonProps } = this.props;
        const addresToCopyProps = getCommonProps('address', 0);
        const propsToReplace = getCommonProps('actual_address');
        return match ? addresToCopyProps.error : propsToReplace.error;
    }

    getActAddressCommonProps = () => {
        const { disabled: globalDisabled, getCommonProps } = this.props;
        const { match } = this.state;
        const { disabled, ...restProps } = getCommonProps('actual_address');
        return {
            ...restProps,
            disabled: match || globalDisabled
        }
    }

    render() {
        const { loading, getCommonProps, intl, inModal, customCheckBoxId, disabled } = this.props;
        const { match } = this.state;

        return (
            <Fragment>
                <ContractsInput colProps={{ md: 12 }}>
                    <IntlInput
                        {...getCommonProps('name', 0)}
                        placeholder={iFMessage({ intl, id: 'contracts.placeholder.fio' })}
                    />
                </ContractsInput>
                <ContractsInput colProps={{ md: 12 }}>
                    <IntlInput {...getCommonProps('phone')} />
                </ContractsInput>


                <ContractsInput colProps={{ md: 12 }}>
                    <IntlInput
                        {...getCommonProps('address', 0)}
                        placeholder={iFMessage({ intl, id: 'contracts.placeholder.address.reg-ip' })}
                    />
                </ContractsInput>

                <ContractsInput colProps={{ md: 12 }}>
                    <IntlInput
                        {...this.getActAddressCommonProps()}
                        placeholder={iFMessage({ intl, id: 'contracts.placeholder.address.act' })}
                        value={this.getActAddressValue()}
                        error={this.getActAddressError()}
                        noErrorText
                    >
                        <CustomControl
                            id={customCheckBoxId}
                            className="custom-control-xs isMatch"
                            name={customCheckBoxId}
                            value={customCheckBoxId}
                            onChange={this.handleChangeMatch}
                            checked={match}
                            disabled={disabled}
                        >
                            <FMessage id="contracts.match.type-1" />
                        </CustomControl>
                    </IntlInput>
                </ContractsInput>
                <ContractsInput colProps={{ md: 6 }}>
                    <IntlInput {...getCommonProps('ogrnip')} />
                </ContractsInput>

                <ContractsInput colProps={{ md: 6 }}>
                    <IntlInput {...getCommonProps('inn')} />
                </ContractsInput>
                <ContractsInput colProps={{ md: 12 }}>
                    <IntlInput
                        {...getCommonProps('bank_name')}
                        placeholder={iFMessage({ intl, id: 'contracts.placeholder.bank.name' })}
                    />
                </ContractsInput>
                <ContractsInput colProps={{ md: 3 }}>
                    <IntlInput {...getCommonProps('bik')} />
                </ContractsInput>

                <ContractsInput colProps={{ md: 9 }}>
                    <IntlInput {...getCommonProps('corr_account')} />
                </ContractsInput>






                <ContractsInput colProps={{ md: 12 }}>
                    <IntlInput {...getCommonProps('bank_account')} />
                </ContractsInput>
                <ContractsInput colProps={{ md: 6 }}>
                    <IntlInput {...getCommonProps('email')} />
                </ContractsInput>

            </Fragment>
        );
    }
}

export default injectIntl(ContractsIPForm);